import React, { useState } from "react";
import GuestLayout from "../layout/guestLayout";
import rightArrow from "../assets/img/arrow-right.svg";
import upload_icon from "../assets/img/upload_icoon.svg";

import { createShortNameFile, errorMessageCreate } from "../util/custom";
import { CallWithAuth } from "../action/apiActions";
import { POST_CONTACT_US } from "../action/apiPath";
import { showToast } from "../util/toastHelper";
import signup_bg from "../assets/img/signup_bg.jpg";
export default function ContactUs() {

  const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      message: "",
    });

      const [errors, setErrors] = useState({});
      const [isSubmit, setIsSubmit] = useState(false);

     const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));

    // if (files && files[0] && name === "image") {
    //   setUploadedImage(URL.createObjectURL(files[0]));
    // }
  };

   const validate = () => {
      const newErrors = {};
      if (!formData.name.trim()) newErrors.name = "Name is required";
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
      if (!formData.phone.trim()) newErrors.phone = "Phone is required";
      if (formData.phone.trim() && isNaN(formData.phone)) newErrors.phone = "Phone number must be numeric";
      if (formData.phone.trim() && parseInt(formData.phone) < 0) newErrors.phone = "Phone number can not be negative";
      if (formData.phone.trim().length < 10 || formData.phone.trim().length > 15) {
        newErrors.phone = "Phone number must be between 10 - 15 digits";
      }
      if (!formData.message.trim()) {
        newErrors.message = "Query is required";
      }
      return newErrors;
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const validationErrors = validate();
      // console.log(validationErrors);
  
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      setErrors({});
      setIsSubmit(true);
  
      try {
        const response = await CallWithAuth("POST", POST_CONTACT_US, formData);
        let message = errorMessageCreate(response?.res?.data?.message);
        if (response?.res?.data?.statusCode === 201) {
          showToast("success", message);
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });
        } else {
          showToast("error", message);
          setIsSubmit(false);
        }
      } catch (err) {}
      setIsSubmit(false);
    };

  return (
    <GuestLayout>
      {/* <section class="from_our_desk">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm">
              <div class="txt_block">
                <h1>The Evolution of Medicine: A Journey Through Time</h1>
                <p>
                  Medicine has come a long way from its ancient roots to the
                  highly advanced science we know today. This article explores
                  the evolution of medicine, highlighting key milestones,
                  innovations, and the future of healthcare. The fall of the
                  Roman Empire led to a stagnation in medical advancements in
                  Europe, while the Islamic Golden Age saw significant progress
                  in medicine. Scholars like Avicenna wrote influential texts
                  such as "The Canon of Medicine," which synthesized knowledge
                  from various cultures. The Renaissance sparked a revival in
                  scientific inquiry. Anatomists like Andreas Vesalius
                  challenged Galenic principles through detailed human
                  dissections, laying the groundwork for modern anatomy.
                </p>

                <h1>The Age of Enlightenment and Modern Medicine</h1>
              </div>
            </div>
            <div class="img_colm">
              <div class="img_block">
                <div class="block_inner"></div>
              </div>
            </div>
          </div>
        </div>
        
      </section> */}

        <section class="from_our_desk">
        
        <>
          <section className="mycustomclass patient_form_block contactUs-page">
            <div class="site_container">
              <div className="image-container">
                <img src={signup_bg} alt="" style={{ height: '775px' }} />
              </div>
              <div class="patient_form">
                <h1 className="csm_page_title">Contact Us</h1>{" "}
                <div className="row">
                  <div className="col-md-12">
                    <div className="field_block">
                      <label>Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="field_block">
                      <label>Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>                    
                  </div>
                  <div className="col-md-12">
                    <div className="field_block">
                      <label>Phone <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="text_field no-spinners"
                      />
                      {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>                    
                  </div>
                  {/* <div className="col-md-6">
                    <div className="field_block">
                      <label>Issue *</label>
                      <input
                        type="text"
                        name="issue"
                        value={formData.issue}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.issue && <p className="error">{errors.issue}</p>}
                    </div>                    
                  </div> */}
                </div>
                <div className="field_block">
                  <label>About Query <span className="text-danger">*</span></label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="text_field"
                  />
                  {errors.message && (
                    <p className="error">{errors.message}</p>
                  )}
                </div>

               

                <div className="field_block">
                  <div className="btn_row mt-3">
                    <button
                      // disabled={isFaceImageLoading || isSubmit}
                      onClick={handleSubmit}
                      disabled={isSubmit}
                    >
                      <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                      {isSubmit && (
                        <>
                          {""}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </section>
    </GuestLayout>
  );
}
